module.exports = __webpack_public_path__ + "img/instagram.5a256a0d.svg";